import script from "./tenantswitch.vue?vue&type=script&setup=true&lang=js"
export * from "./tenantswitch.vue?vue&type=script&setup=true&lang=js"

import "./tenantswitch.vue?vue&type=style&index=0&id=4cb1dd6a&lang=scss&scoped=true"

import exportComponent from "/root/buildarea/v8-development-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4cb1dd6a"]])

export default __exports__